import { UserContext } from '@/providers/user-provider'
import { ReactNode, use } from 'react'

interface Props {
    children: ReactNode
}

export const HiddenWhenNotConsultant = ({ children }: Props): ReactNode | undefined => {
    const { isConsultant } = use(UserContext)

    if (!isConsultant) return undefined

    return children
}
